import axios from 'axios';
import config from '@this/impl/config';
import Membership from './membership';
import Contents from './contents';
import Rules from './rules';
import Public from './public';
import Health from './health';
import { postData } from './base';

export const localLogin = async (
	username: string,
	password: string,
): Promise<{ access_token: string }> => {
	const response = await postData('/auth/login/local', { username, password });
	return response.data;
};

export const impersonateLogin = async (
	targetEmail: string,
	password: string,
): Promise<{ access_token: string }> => {
	const response = await postData('/auth/login/impersonate', { targetEmail, password });
	return response.data;
};

export const getImpersonateUsers = async (): Promise<{ name: string; email: string }[]> => {
	const response = await axios.get(`${config.apiHost}/auth/login/impersonate/users`);
	return response.data;
};

export default {
	Public,
	Membership,
	Contents,
	Rules,
	Health,
};
